<template>
	<layout-admin-basic class="admin-dashboard">
		<div slot="breadcrumbs"><admin-breadcrumbs :breadcrumbs="breadcrumbs"/></div>
		<span slot="header">{{ title }}</span>
		<ul>
			<li><router-link :to="{ name: 'AdminDeviceList' }">Devices</router-link></li>
			<!--li><router-link :to="{ name: 'AdminUserList' }">Users</router-link></li-->
			<li><router-link :to="{ name: 'AdminSubscriptionList' }">Subscriptions</router-link></li>
			<li><router-link :to="{ name: 'AdminServiceList' }">Services</router-link></li>
			<li><router-link :to="{ name: 'AdminReadingTypesList' }">Reading Types List</router-link></li>
			<li><router-link :to="{ name: 'AdminDiseaseNamesList' }">Disease Names List</router-link></li>
			<li><router-link :to="{ name: 'AdminSSNumberTypesList' }">Social Security Number Types List</router-link></li>
			<li><router-link :to="{ name: 'AdminMDCategoriesList' }">Medical Document Categories List</router-link></li>
		</ul>
		<ul>
			<li><router-link :to="{ name: 'AdminStaticContentUsePolicy' }">Use Policy</router-link></li>
			<li><router-link :to="{ name: 'AdminStaticContentPrivacyPolicy' }">Privacy Policy</router-link></li>
			<li><router-link :to="{ name: 'AdminStaticContentTerms' }">Terms Of Use</router-link></li>
		</ul>
		<ul>
			<li><router-link :to="{ name: 'AdminHelpContent' }">Help Pages</router-link></li>
		</ul>
	</layout-admin-basic>
</template>

<script>
import LayoutAdminBasic from './LayoutAdminBasic'
import AdminBreadcrumbs from './AdminBreadcrumbs'
export default {
	components: {
		LayoutAdminBasic,
		AdminBreadcrumbs
	},
	data () {
		return {
			title: 'Dashboard'
		}
	},
	computed: {
		breadcrumbs () {
			return [
				{
					title: this.header
				}
			]
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminDashboard.vue